import { getDisclaimer } from '../config/disclaimers';
import styles from './DisclaimerMarker.module.css';

/**
 * A small superscript footnote marker (e.g. `¹`) placed next to a chart title,
 * pointing at the matching numbered entry in the page-bottom `DisclaimerFooter`.
 * The number and accessible label come from the shared `disclaimers` registry
 * (keyed by `id`), so a chart never hardcodes a footnote number that could
 * drift out of sync with the footer.
 *
 * Renders nothing for an unknown id (a mis-typed marker simply doesn't show,
 * rather than pointing at the wrong footnote). The footer entry it references
 * gets `id="disclaimer-<n>"`, and this marker links to it via a bare `#`
 * fragment anchor so keyboard/screen-reader users can jump to the note.
 */
const DisclaimerMarker = ({ id }) => {
  const disclaimer = getDisclaimer(id);
  if (!disclaimer) return null;

  const { number, short } = disclaimer;
  return (
    <sup className={styles.marker}>
      <a
        href={`#disclaimer-${number}`}
        className={styles.link}
        aria-label={`Footnote ${number}: ${short} (see disclaimers at bottom of page)`}
        title={short}
      >
        {number}
      </a>
    </sup>
  );
};

export default DisclaimerMarker;
